module.exports = __webpack_public_path__ + "img/Oplates (OPI).bb97b4cb.png";